import { globals } from 'common-ui';
import Image from 'next/image';

const DefaultImage = ({ imageURL, isCase, largeProductMultiView }: any) => {
  const PRODUCT_IMAGE = 'Product Image';
  const PRODUCT_CASE_DEFAULT_IMAGE = 'product-case-default-image';
  const PRODUCT_BOTTLE_IMAGE = 'product-bottle-image';

  const handleImageError = () => `${globals.publicHost}${globals.defaultImagePath}/${isCase ? 'default_case' : 'default_bottle'}.png`;

  return (
    <div className="product-image">
      <Image
        src={imageURL}
        alt={PRODUCT_IMAGE}
        className={`${isCase ? PRODUCT_CASE_DEFAULT_IMAGE : PRODUCT_BOTTLE_IMAGE}${imageURL?.includes('default_') ? ' product-image-error' : ''}`}
        width={`${largeProductMultiView ? '1800' : '600'}`}
        height={`${largeProductMultiView ? '1200' : '400'}`}
        onError={() => handleImageError()}
        objectFit="cover"
      />
    </div>
  );
};

export default DefaultImage;
